import { useIsMerchant } from "../hooks/use-is-merchant";
import {
  filterReturnableItems,
  splitByReturnability,
} from "../lib/returnable-items.lib";
import type { OrderLineItem } from "../types";
import { usePublicOrder } from "./use-public-order";
import { useReturnRequests } from "./use-return-requests";

// A merchant creating a return on behalf of a customer keeps every article,
// same bypass as the store list and the maintenance gate. The backend accepts
// those lines: `CheckItemsReturnableService` only guards quantities.
export function useReturnableItems(
  orderId: string,
  shopSlug: string,
): OrderLineItem[] {
  const { data: order } = usePublicOrder(orderId);
  const { data: returnRequestsData } = useReturnRequests({ orderId, shopSlug });
  const isMerchant = useIsMerchant();

  const lineItems = order?.lineItems ?? [];
  const returnRequests = returnRequestsData?.returnRequests ?? [];

  return isMerchant
    ? filterReturnableItems(lineItems, returnRequests)
    : splitByReturnability(lineItems, returnRequests).returnable;
}
